import {
  Box,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  CircularProgress,
} from '@mui/material'
import { Modal } from 'Common/Supplyvue-ui'
import {
  ContentWrapper,
  ModalActionButton,
  Label,
  StyledFooter,
} from './ScenarioAccess.styles'
import { ScenarioAccessModalProps } from './ScenarioAccess.types'
import { useScenarios } from './ScenarioAccess.data'
import { Scenario } from '../ProjectDetails/ProjectDetails.types'

import { ScenarioAccessToggle } from './ScenarioAccessToggle.view'
import { useEffect, useState } from 'react'

export const ScenarioAccessModal = ({
  isModalOpen,
  handleModalClose,
  heading,
  projectId,
  isLoading,
  handleScenarioAccessApply,
  scenarioAccessConfig,
}: ScenarioAccessModalProps) => {
  const [scenarioAccessConfiguration, setScenarioAccessConfiguration] =
    useState<{ [key: string]: 'public' | 'private' }>(scenarioAccessConfig)
  const { data: scenarios, isLoading: isScenarioDataLoading } =
    useScenarios(projectId)

  useEffect(() => {
    if (isModalOpen) {
      setScenarioAccessConfiguration(scenarioAccessConfig)
    } else {
      setScenarioAccessConfiguration({})
    }
  }, [isModalOpen, projectId])

  const handleScenarioAccessChange = (
    scenarioId: string,
    access: 'public' | 'private'
  ) => {
    setScenarioAccessConfiguration({
      ...scenarioAccessConfiguration,
      [scenarioId]: access,
    })
  }

  const handeleApply = () => {
    handleScenarioAccessApply(scenarioAccessConfiguration)
  }

  const Body = (
    <ContentWrapper>
      <Label variant="h4">
        Please configure scenario access when the project becomes public.
      </Label>
      <Box>
        {isScenarioDataLoading ? (
          <CircularProgress />
        ) : (
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Scenario</TableCell>
                  <TableCell align="center">Access</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {scenarios?.map((row: Scenario) => (
                  <TableRow
                    key={row.scenarioId}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {row.scenarioName}
                    </TableCell>
                    <TableCell align="center">
                      <ScenarioAccessToggle
                        access={
                          scenarioAccessConfig[row.scenarioId] ?? 'public'
                        }
                        scenarioId={row.scenarioId}
                        handleScenarioAccessChange={handleScenarioAccessChange}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </ContentWrapper>
  )

  const Footer = (
    <StyledFooter>
      <ModalActionButton
        onClick={() => {
          handeleApply()
        }}
        label={isLoading ? 'Applying...' : 'Apply'}
        variant="contained"
        disabled={Object.keys(scenarioAccessConfiguration).length === 0}
      >
        {isLoading && (
          <CircularProgress
            color="inherit"
            size={16}
            sx={{ marginRight: '8px' }}
          />
        )}
        Apply
      </ModalActionButton>
    </StyledFooter>
  )

  return (
    <Modal
      aria-labelledby={heading}
      header={heading}
      open={isModalOpen}
      handleClose={handleModalClose}
      body={Body}
      footer={Footer}
    />
  )
}
